export const HOME_CATEGORY_ID = 32;
export const CART_CATEGORY_ID = 35;
export const CHECKOUT_CATEGORY_ID = 58;
//# sourceMappingURL=constants.js.map